/* eslint-disable */
const transfer = require('./transfer');

module.exports = {
  ...transfer,
  name: "bca_bank_transfer",
}